import _get from 'lodash.get';
import { UNIFIED_FEED_DOMAIN } from 'constants/index';
import jsonp from 'jsonp';
import reducerRegistry from '../../reduxUtils/reducerRegistry';
import makeRequest from '../../utils/makeRequest';
import * as cookie from '../../utils/cookies';

const reducerName = 'videoshow';
const createActionName = name => `toi/${reducerName}/${name}`;

export const RECEIVE_VIDEO_RHS_DATA = createActionName(
  'RECEIVE_VIDEO_RHS_DATA',
);
export const ADD_TO_WATCHED = createActionName('ADD_TO_WATCHED');
export const HANDLE_DATA_ERROR = createActionName('HANDLE_DATA_ERROR');
export const RECEIVE_VIDEO_DATA = createActionName('RECEIVE_VIDEO_DATA');
export const ADD_NEXT_VIDEO_MSID = createActionName('ADD_NEXT_VIDEO_MSID');
export const REMOVE_NEXT_MSID = createActionName('REMOVE_NEXT_MSID');
export const RECEIVE_BOTTOM_VIDEO_DATA = createActionName(
  'RECEIVE_BOTTOM_VIDEO_DATA',
);
export const SET_VIDEO_MSID_DATA = createActionName('SET_VIDEO_MSID_DATA');
export const RECEIVE_VIDEOSHOW_DATA = createActionName(
  'RECEIVE_VIDEOSHOW_DATA',
);
export const RECEIVE_RELATED_ARTICLES_DATA = createActionName(
  'RECEIVE_RELATED_ARTICLES_DATA',
);

const VIDEOSHOW_FEED_PATH = 'wufs/feed/show/video?pc=toi&dm=t&client=toi';

function fetchRhsVideoData(params) {
  const url = `/feeds/feed_videoshow_side_widget/msid-${
    params.msid
  },feedtype-sjson${params.isWapView ? ',frmwap-yes' : ''}${
    params.isFromEtimes ? ',frmetimes-yes' : ''
  }.cms`;

  return makeRequest.get(url, {}, 'skipfeedengine');
}
function fetchVideoData(params) {
  const url = `/feeds/feed_videoshow/msid-${params.msid},feedtype-sjson${
    params.isWapView ? ',frmwap-yes' : ''
  }${params.isFromEtimes ? ',frmetimes-yes' : ''}.cms`;

  return makeRequest.get(url, {}, 'skipfeedengine');
}
function fetchVideoBottomData(params) {
  let url;
  if (params.isEtimes) {
    url = `/feeds/feed_videoshow_etimes_bottom_widget/msid-${
      params.msid
    },feedtype-sjson${params.isWapView ? ',frmwap-yes' : ''}.cms`;
  } else {
    url = `/feeds/feed_videoshow_bottom_widget/msid-${
      params.msid
    },feedtype-sjson${params.isWapView ? ',frmwap-yes' : ''}.cms`;
  }
  return makeRequest.get(url, {}, 'skipfeedengine');
}

function fetchVideoshowData(params) {
  const url = `${UNIFIED_FEED_DOMAIN}/${VIDEOSHOW_FEED_PATH}&msid=${
    params.msid
  }`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

function fetchRelatedArticlesData(params, raurl) {
  const parts = params.split(',');
  const firstWord = parts[0] && parts[0] !== '' ? parts[0].trim() : '';
  const url =
    typeof raurl === 'string' && raurl.indexOf('<query>') > -1
      ? raurl.replace('<query>', firstWord)
      : `${raurl}&query=${firstWord}`;
  return makeRequest.get(url, {}, 'skipfeedengine');
}

function receiveRhsVideolistdata(data) {
  return {
    type: RECEIVE_VIDEO_RHS_DATA,
    payload: data.data,
  };
}

function receiveVideodata(data) {
  return {
    type: RECEIVE_VIDEO_DATA,
    payload: data,
  };
}

function handleRhsVideoDataError() {
  return {
    type: HANDLE_DATA_ERROR,
  };
}
function handleAddToWatchedHistory(msid) {
  return {
    type: ADD_TO_WATCHED,
    payload: msid,
  };
}
function receiveBottomVideodata(bottomVideoListing = { data: { items: [] } }) {
  const bottomVideoListingReduced = {
    ...bottomVideoListing,
  };
  const dataLength = bottomVideoListingReduced.data.items.length;
  if (dataLength > 5 && dataLength < 10) {
    bottomVideoListingReduced.data.items = bottomVideoListingReduced.data.items.filter(
      (item, index) => index < 5,
    );
  } else if (dataLength > 10) {
    bottomVideoListingReduced.data.items = bottomVideoListingReduced.data.items.filter(
      (item, index) => index < 10,
    );
  }
  return {
    type: RECEIVE_BOTTOM_VIDEO_DATA,
    payload: bottomVideoListingReduced,
  };
}
function receiveBottomVideodataEtimes(
  bottomVideoListing = { data: { items: [] } },
) {
  const bottomVideoListingReduced = {
    ...bottomVideoListing,
  };
  return {
    type: RECEIVE_BOTTOM_VIDEO_DATA,
    payload: bottomVideoListingReduced,
  };
}
function addToWatchedHistoryCall(msid, callback) {
  const url = `https://myt.indiatimes.com/mytimes/addActivity?appKey=TOI&baseEntityType=VIDEO&objectType=B&activityType=Watched&uniqueAppID=${msid}`;
  const ssoid = cookie.getCookie('ssoid');
  if (ssoid) {
    jsonp(url, null, callback);
  }
}
function receiveVideoshowdata(data) {
  return {
    type: RECEIVE_VIDEOSHOW_DATA,
    payload: data,
  };
}

function receiveRelatedArticlesData(data) {
  return {
    type: RECEIVE_RELATED_ARTICLES_DATA,
    payload: data,
  };
}

export function addNextVideoMsid(msidForNextVideo, slikeId) {
  return {
    type: ADD_NEXT_VIDEO_MSID,
    payload: { msidForNextVideo, slikeId },
  };
}

export function removeNextMsid() {
  return {
    type: REMOVE_NEXT_MSID,
    payload: undefined,
  };
}

export function setVideoMsidData(msid) {
  return {
    type: SET_VIDEO_MSID_DATA,
    payload: {
      msid,
    },
  };
}
export function addToWatched(msid) {
  return dispatch =>
    addToWatchedHistoryCall(msid, (error, data) => {
      if (!error) {
        dispatch(handleAddToWatchedHistory(msid, data));
      }
    });
}
export function loadRhsVideoData(params) {
  return dispatch =>
    fetchRhsVideoData(params)
      .then(data => dispatch(receiveRhsVideolistdata(data.data, params)))
      .catch(error => dispatch(handleRhsVideoDataError(error)));
}
export function loadVideoData(params) {
  return dispatch =>
    fetchVideoData(params)
      .then(data => dispatch(receiveVideodata(data.data, params)))
      .catch(error => dispatch(handleRhsVideoDataError(error)));
}
export function loadVideoBottomData(params) {
  return dispatch =>
    fetchVideoBottomData(params)
      .then(response => {
        if (params.isEtimes) {
          dispatch(receiveBottomVideodataEtimes(response.data, params));
        } else {
          dispatch(receiveBottomVideodata(response.data, params));
        }
      })
      .catch(error => {
        dispatch(handleRhsVideoDataError(error));
      });
}

export function loadVideoshowData(params, callback) {
  return dispatch =>
    fetchVideoshowData(params)
      .then(response => {
        dispatch(receiveVideoshowdata(response.data, params));
        if (typeof callback === 'function') {
          callback(response.data);
        }
      })
      .catch(error => {
        dispatch(handleRhsVideoDataError(error));
      });
}

export function loadRelatedArticlesData(params, raurl) {
  return dispatch =>
    fetchRelatedArticlesData(params, raurl)
      .then(response => {
        dispatch(receiveRelatedArticlesData(response.data, params));
      })
      .catch(error => {
        dispatch(handleRhsVideoDataError(error));
      });
}

export default function reducer(state = {}, action = {}) {
  // console.log(action);
  switch (action.type) {
    case RECEIVE_VIDEO_RHS_DATA: {
      return {
        ...state,
        videoRhsData: action.payload,
      };
    }
    case RECEIVE_VIDEO_DATA: {
      if (typeof document === 'object') {
        document.title =
          action.payload &&
          action.payload.seoData &&
          action.payload.seoData.data
            ? action.payload.seoData.data.title
            : document.title;
      }
      if (
        typeof document === 'object' &&
        _get(action.payload, 'isPrime', undefined)
      ) {
        window.location.href = _get(
          action.payload,
          'seoData.data.canonical',
          '',
        );
      }
      return {
        ...state,
        videoData: action.payload,
      };
    }
    case REMOVE_NEXT_MSID: {
      return {
        ...state,
        msidForNextVideo: action.payload,
      };
    }
    case ADD_NEXT_VIDEO_MSID: {
      return {
        ...state,
        msidForNextVideo: action.payload.msidForNextVideo,
        slikeId: action.payload.slikeId,
      };
    }
    case RECEIVE_BOTTOM_VIDEO_DATA: {
      return {
        ...state,
        bottomVideoData: action.payload,
      };
    }
    case SET_VIDEO_MSID_DATA: {
      return {
        ...state,
        videoData: action.payload,
      };
    }
    case ADD_TO_WATCHED: {
      return {
        ...state,
        // watched: action.payload, // maybe show user has watched in video
      };
    }
    case RECEIVE_VIDEOSHOW_DATA: {
      if (typeof document === 'object') {
        document.title =
          action.payload &&
          action.payload.pwa_meta &&
          action.payload.pwa_meta.ogtitle
            ? action.payload.pwa_meta.ogtitle
            : document.title;
      }
      // if (typeof document === 'object') {
      //   window.location.href = _get(action.payload, 'pwa_meta.canonical', '');
      // }
      return {
        ...state,
        videoshowData: action.payload,
      };
    }
    case RECEIVE_RELATED_ARTICLES_DATA: {
      return {
        ...state,
        relatedarticles: action.payload,
      };
    }
    default:
      return state;
  }
}

reducerRegistry.register(reducerName, reducer);
